import { AwardsIconsSlider, AwardsLogosSlider } from '../../../js/src/__utils/sliders';
import Swiper from 'swiper/bundle';

window.Swiper = Swiper;
const NewsLogosSliderNew = () => {
    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        spaceBetween: 25,
        loop: true,
        loopedSlides: 3,
        loopedSlidesLimit: true,
        slidesPerView: 'auto',
        speed: 3000,
        grabCursor: true,
        mousewheelControl: true,
        keyboardControl: true,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        freeMode: {
            enabled: true,
            sticky: true,
        },
    });
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        AwardsIconsSlider.init();
        if ( window.innerWidth < 992 ) {
            NewsLogosSliderNew();
        }
    },
    loaded() {},
    resized() {
        AwardsIconsSlider.init();
        if ( window.innerWidth < 992 ) {
            NewsLogosSliderNew();
        }
    },
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
